/*
  Psikband – koszyk: wybór paczkomatu InPost + oferta drugiej bransoletki.
  Markup: snippets/psikband-koszyk.liquid. Szuflada koszyka jest re-renderowana przez motyw,
  dlatego wszystko działa przez delegację zdarzeń na dokumencie.
  Punkty: publiczne API InPost (api-pl-points.easypack24.net) – bez tokena i bez aplikacji.
*/
(function () {
  if (window.psikbandKoszyk) return;
  window.psikbandKoszyk = true;

  var API = 'https://api-pl-points.easypack24.net/v1/points';
  var POLA = 'name,address_details,location_description,distance,status';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function jestPaczkomatem(p) {
    // tylko paczkomaty (np. WAW01M, KRA123A) – bez PaczkoPunktów POP-/PNET
    return p && p.status === 'Operating' && /^[A-Z]{3}\d{1,4}[A-Z]{0,3}$/.test(p.name || '');
  }

  function adres(p) {
    var a = p.address_details || {};
    var ulica = [a.street, a.building_number].filter(Boolean).join(' ');
    return [ulica, [a.post_code, a.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  }

  function odleglosc(m) {
    if (m == null || m === '') return '';
    return m < 1000 ? Math.round(m) + ' m' : (m / 1000).toFixed(1).replace('.', ',') + ' km';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function aktualizujAtrybuty(atrybuty) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: atrybuty })
    });
  }

  function pokazWyniki(pk, html) {
    var box = pk.querySelector('[data-pk-wyniki]');
    if (box) box.innerHTML = html;
  }

  function szukaj(pk, parametry) {
    pokazWyniki(pk, '<p class="pk__info">Szukam paczkomatów…</p>');
    var url = API + '?type=parcel_locker&per_page=25&fields=' + POLA + '&' + parametry;
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var lista = (j.items || []).filter(jestPaczkomatem).slice(0, 8);
        if (!lista.length) {
          pokazWyniki(pk, '<p class="pk__info">Nie znalazłem paczkomatów. Spróbuj z kodem pocztowym, np. 00-001.</p>');
          return;
        }
        pokazWyniki(pk, lista.map(function (p) {
          var a = adres(p);
          var d = odleglosc(p.distance);
          return '<button type="button" class="pk__wynik" data-pk-wybierz="' + esc(p.name) + '" data-pk-adres="' + esc(a) + '">' +
            '<strong>' + esc(p.name) + '</strong>' + (d ? ' · ' + d : '') +
            '<small>' + esc(a) + '</small>' +
            (p.location_description ? '<small>' + esc(p.location_description) + '</small>' : '') +
            '</button>';
        }).join(''));
      })
      .catch(function () {
        pokazWyniki(pk, '<p class="pk__info">Nie udało się pobrać listy paczkomatów. Spróbuj ponownie za chwilę.</p>');
      });
  }

  function szukajPoFrazie(pk) {
    var pole = pk.querySelector('[data-pk-q]');
    var q = (pole && pole.value || '').trim();
    if (!q) { if (pole) pole.focus(); return; }
    var kodPocztowy = q.match(/^(\d{2})-?(\d{3})$/);
    if (kodPocztowy) return szukaj(pk, 'relative_post_code=' + kodPocztowy[1] + '-' + kodPocztowy[2] + '&max_distance=8000');
    if (/^[a-z]{3}\d{1,4}[a-z]{0,3}$/i.test(q)) {
      // wpisany bezpośrednio kod paczkomatu
      pokazWyniki(pk, '<p class="pk__info">Sprawdzam paczkomat…</p>');
      return fetch(API + '/' + encodeURIComponent(q.toUpperCase()))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (jestPaczkomatem(p)) {
            pokazWyniki(pk, '<button type="button" class="pk__wynik" data-pk-wybierz="' + esc(p.name) + '" data-pk-adres="' + esc(adres(p)) + '"><strong>' + esc(p.name) + '</strong><small>' + esc(adres(p)) + '</small></button>');
          } else {
            szukaj(pk, 'city=' + encodeURIComponent(q));
          }
        });
    }
    return szukaj(pk, 'city=' + encodeURIComponent(q));
  }

  function ustawWybrany(pk, kod, adr) {
    pk.setAttribute('data-pk-kod', kod || '');
    var wybrany = pk.querySelector('[data-pk-wybrany]');
    var szukajBox = pk.querySelector('[data-pk-szukaj]');
    var blad = pk.querySelector('[data-pk-blad]');
    if (kod) {
      pk.querySelector('[data-pk-wybrany-kod]').textContent = kod;
      pk.querySelector('[data-pk-wybrany-adres]').textContent = adr || '';
      wybrany.hidden = false;
      szukajBox.hidden = true;
      if (blad) blad.hidden = true;
    } else {
      wybrany.hidden = true;
      szukajBox.hidden = false;
    }
  }

  function wybranaDostawa(pk) {
    var r = pk.querySelector('input[name="pk-dostawa"]:checked');
    return r ? r.value : 'Paczkomat InPost';
  }

  // --- kliknięcia ---
  document.addEventListener('click', function (e) {
    var t = e.target;
    var pk = t.closest && t.closest('[data-pk]');

    if (pk && t.closest('[data-pk-znajdz]')) { szukajPoFrazie(pk); return; }

    if (pk && t.closest('[data-pk-geo]')) {
      if (!navigator.geolocation) { pokazWyniki(pk, '<p class="pk__info">Twoja przeglądarka nie udostępnia lokalizacji – wpisz kod pocztowy.</p>'); return; }
      pokazWyniki(pk, '<p class="pk__info">Ustalam lokalizację…</p>');
      navigator.geolocation.getCurrentPosition(function (pos) {
        szukaj(pk, 'relative_point=' + pos.coords.latitude.toFixed(5) + ',' + pos.coords.longitude.toFixed(5) + '&max_distance=5000');
      }, function () {
        pokazWyniki(pk, '<p class="pk__info">Brak dostępu do lokalizacji – wpisz kod pocztowy lub miasto.</p>');
      }, { timeout: 10000 });
      return;
    }

    var wyb = t.closest && t.closest('[data-pk-wybierz]');
    if (pk && wyb) {
      var kod = wyb.getAttribute('data-pk-wybierz');
      var adr = wyb.getAttribute('data-pk-adres');
      ustawWybrany(pk, kod, adr);
      aktualizujAtrybuty({ 'Dostawa': 'Paczkomat InPost', 'Paczkomat': kod, 'Paczkomat adres': adr });
      return;
    }

    if (pk && t.closest('[data-pk-zmien]')) {
      ustawWybrany(pk, '', '');
      var pole = pk.querySelector('[data-pk-q]');
      if (pole) pole.focus();
      return;
    }

    var dodaj = t.closest && t.closest('[data-pk-druga-dodaj]');
    if (dodaj) { dodajDruga(dodaj); return; }
  });

  // --- zmiana: paczkomat / kurier ---
  document.addEventListener('change', function (e) {
    if (e.target.name !== 'pk-dostawa') return;
    var pk = e.target.closest('[data-pk]');
    if (!pk) return;
    var kurier = e.target.value === 'Kurier';
    pk.querySelector('[data-pk-panel]').hidden = kurier;
    aktualizujAtrybuty(kurier
      ? { 'Dostawa': 'Kurier', 'Paczkomat': '', 'Paczkomat adres': '' }
      : { 'Dostawa': 'Paczkomat InPost' });
    if (kurier) pk.setAttribute('data-pk-kod', '');
  });

  // Enter w polu wyszukiwania nie może wysłać formularza koszyka (= przejścia do kasy)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-pk-q]')) {
      e.preventDefault();
      szukajPoFrazie(e.target.closest('[data-pk]'));
    }
  }, true);

  // --- blokada kasy bez wybranego paczkomatu ---
  function sprawdzPrzedKasa(e, element) {
    var zakres = (element && (element.closest('cart-drawer') || element.closest('form'))) || document;
    var pk = zakres.querySelector('[data-pk]') || document.querySelector('[data-pk]');
    if (!pk) return;
    if (wybranaDostawa(pk) === 'Kurier' || pk.getAttribute('data-pk-kod')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var blad = pk.querySelector('[data-pk-blad]');
    if (blad) blad.hidden = false;
    pk.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var pole = pk.querySelector('[data-pk-q]');
    if (pole) setTimeout(function () { pole.focus({ preventScroll: true }); }, 350);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#CartDrawer-Checkout, button[name="checkout"], a[href$="/checkout"]');
    if (btn) sprawdzPrzedKasa(e, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (sub && sub.name === 'checkout') sprawdzPrzedKasa(e, sub);
  }, true);

  // --- druga bransoletka ---
  function dodajDruga(przycisk) {
    var box = przycisk.closest('.pk-druga');
    var select = box && box.querySelector('[data-pk-druga-wariant]');
    if (!select) return;
    przycisk.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var sekcje = [];
    try { sekcje = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : []; } catch (err) { sekcje = []; }
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }], sections: sekcje, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (drawer && typeof drawer.renderContents === 'function' && json.sections) {
          try { drawer.renderContents(json); return; } catch (err) { /* fallback niżej */ }
        }
        window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }
})();
